import { PayloadAction } from '@reduxjs/toolkit'
import { IRequestByPartnerId } from 'legacy/lut/classes/models/service'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { IEPRecord } from 'partner360/models/masterDealer'

import { IMasterDealerDataState } from '../models'

export const getMasterDealerDataByIdPending = (
  state: IMasterDealerDataState,
  action: PayloadAction<unknown, string, { arg: IRequestByPartnerId }>
) => {
  const { meta } = action

  state.base.data = new Map([])
  state.base.meta = meta
  state.base.status = RequestStatus.PENDING
  state.base.message = ''
}

export const getMasterDealerDataByIdRejected = (
  state: IMasterDealerDataState,
  action: PayloadAction<unknown, string, { arg: IRequestByPartnerId }>
) => {
  const { meta } = action

  state.base.meta = meta
  state.base.status = RequestStatus.REJECTED
  state.base.message = action.payload as string
}

export const getMasterDealerDataByIdFulfilled = (
  state: IMasterDealerDataState,
  action: PayloadAction<IEPRecord[], string, { arg: IRequestByPartnerId }>
) => {
  const { meta, payload } = action

  state.base.meta = meta
  state.base.status = RequestStatus.FULFILLED
  state.base.message = ''
  if (payload) {
    state.base.data = new Map(payload.map((record) => [record.epPartnerId, record]))
  }
}
